var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnwendbarAnPrallerSonne = function SvgAnwendbarAnPrallerSonne(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Anwendbar_an_praller_Sonne_svg__Ebene_2",
    viewBox: "0 0 118.08 92.24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Anwendbar_an_praller_Sonne_svg__cls-2{fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2.43px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Anwendbar_an_praller_Sonne_svg__Layer_1"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.83,
    cy: 30.19,
    r: 19.85,
    className: "Anwendbar_an_praller_Sonne_svg__cls-2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.83 7.39V1.21M91.31 10.49l3.11-5.34M99.66 18.94l5.38-3.04M102.63 30.46l6.17.07M99.4 41.9l5.3 3.17M90.84 50.16l2.99 5.4M79.3 52.99l-.15 6.17M67.89 49.62l-3.23 5.26M59.74 40.97l-5.45 2.92M57.04 29.39l-6.17-.22M60.54 18.03l-5.22-3.29M69.29 9.97 66.43 4.5",
    className: "Anwendbar_an_praller_Sonne_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m117.83 60.98-9.18-4.93c-1.16-.32-1.8.13-2.02.66-.25.61.04 1.32.69 1.68l5.64 2.93-53.83 27.94-53.94-28.8 40.12-21.17.06-.03.04-.06c.07-.11.65-1.12.22-1.79-.26-.4-.8-.56-1.62-.46l-.09.03C43.47 37.22.26 60.02.26 60.02c-.16.07-.26.24-.26.42s.1.35.26.43l58.62 31.31c.07.04.15.06.23.06s.16-.02.23-.05l58.48-30.35a.5.5 0 0 0 .01-.87Z",
    style: {
      fill: "currentColor"
    }
  })));
};
export default SvgAnwendbarAnPrallerSonne;